export var isLocalhost = typeof window !== 'undefined' && /localhost/.test(window.location.hostname);
var isPrPlayground = function isPrPlayground() {
  if (typeof window === 'undefined') {
    return false;
  }
  var hostname = window.location.hostname;
  return prPlaygrounds.some(function (pgUrl) {
    return hostname.includes(pgUrl);
  });
};
var prPlaygrounds = ['.writing-playground.easybib.com', '.writing-playground.bibme.org', '.writing-playground.citationmachine.net', '.writing.dev.cheggnet.com'];
export var PRPLAYGROUND_OR_LOCAL = typeof window !== 'undefined' && (isLocalhost || isPrPlayground());